import { render, staticRenderFns } from "./ControlButtons.vue?vue&type=template&id=2743ffa0&"
import script from "./ControlButtons.vue?vue&type=script&lang=js&"
export * from "./ControlButtons.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ControlButtons.vue?vue&type=style&index=0&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports